<template>
  <BaseExpansionPanel
    bold-label
    :caption="description"
    data-testid="toggle-list"
    :label="label"
  >
    <div class="tw:flex tw:flex-col tw:gap-3">
      <div
        v-for="(item, itemIndex) in items"
        :key="itemIndex"
      >
        <Radio
          v-model="modelValue"
          :color="medium"
          dense
          :disabled="item.disabled"
          :label="item.name"
          :name="name"
          new-design
          :value="item.id"
        />
        <div
          v-if="item.description"
          class="tw:mt-2 tw:pl-6"
          :data-testid="`radio-item-${item.id}-description`"
        >
          {{ item.description }}
        </div>
      </div>
    </div>
  </BaseExpansionPanel>
</template>

<script setup lang="ts">
import { computed } from "vue";

import BaseExpansionPanel from "shared/components/base/BaseExpansionPanel.vue";
import Radio from "shared/components/core/forms/Radio.vue";

export interface BaseRadioSelectorItem {
  id: string | boolean;
  name: string;
  description?: string;
  disabled?: boolean;
}

interface BaseRadioSelectorProps {
  label: string;
  description?: string;
  items: BaseRadioSelectorItem[];
  medium: string;
}

const modelValue = defineModel<boolean | string>({ default: false });

const props = withDefaults(defineProps<BaseRadioSelectorProps>(), {
  description: "",
});

const name = computed(() => props.label.toLowerCase().replace(" ", "-"));
</script>
